import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ba3e2d8a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ba3e2d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3e2d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba3e2d8a')) {
      api.createRecord('ba3e2d8a', component.options)
    } else {
      api.reload('ba3e2d8a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ba3e2d8a&scoped=true&", function () {
      api.rerender('ba3e2d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8MoZ2adRwiYg9/JS/comp/PopupDialog.vue"
export default component.exports